/* eslint-disable import/prefer-default-export */
import { useAtom } from 'jotai';

import { userAtom } from './user.atoms';

export default function useUser() {
    const [user, setUser] = useAtom(userAtom);

    return {
        user,
        setUser,
    };
}
